// Smooth scroll on click the link with hash
const anchors = document.querySelectorAll('[href^="#"]');
anchors.forEach(anchor => {
    if (anchor.classList.contains('js-smooth-scroll')) {
        anchor.addEventListener('click', event => {
            event.preventDefault();
            const targetElId = anchor.hash.slice(1);
            const targetEl = document.getElementById(targetElId);
            const yOffset = -120;
            const y =
                targetEl.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset;
            if (targetEl) {
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        });
    }
});
